<template>
	<div class="bg-white shadow-sm rounded" style="border: 1px solid rgb(222, 222, 222, 0.5)">
		<div v-if="!configcollection?.hidePostHeader" class="flex items-center p-3 border-b border-gray-200 flex-wrap">
			<div class="flex">
				<EditButton v-if="configcollection?.editmode && !configcollection?.hideConfigButton" class="rounded hover:bg-secondary-500/80 items-center py-1 px-1 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white mr-2"
				:id="callout.identifier" type="configAssistantMode"/>
				<InplaceEdit
					v-if="configcollection?.editmode && !isLanguageReviewMode"
					:inputProps="[{ content: callout.packageTitle, propName: 'packageTitle', inputType: 'packageTitle' }]"
					:collectionMode="configcollection"
					:href="callout._links?.self?.href" blockTitle="Edit package title" :showAssistant="true">
					<strong class="ml-1">{{ callout.packageTitle }}</strong>
				</InplaceEdit>
					<strong v-else class="ml-1">{{ callout.packageTitle }}</strong>
			</div>
			<div class="ml-auto flex items-center">
				<EditButton
					class="rounded flex flex-row hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white mr-2"
					v-if="!configcollection?.hideFeedbackListButton && hasFeedbackListUrl"
					:modal="isModalFeedback"
					:id="callout.identifier" type="feedbackList"
					:buttonLabel="'Feedback List'"
					@click="console.log('FeedbackListUrl:', feedbackListUrl)"
					:overrideURL="feedbackListUrl" />

					
				<button v-if="configcollection?.editmode && !configcollection?.hideDeleteActions"
					class="rounded hover:bg-danger-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-danger-500 transition-all bg-danger !text-white mr-2" @click="deleteItem(callout._links?.self?.href)">
					<i class="tabler:trash w-5 h-5 text-white flex"></i>
				</button>
				<EditButton v-if="configcollection?.editmode && !configcollection?.hideEditAll"
					class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white"
					:id="callout.identifier" icon="tabler:settings" type="editPackage"
					@click="console.log('editPackageUrl:', editPackageUrl)"
					:overrideURL="editPackageUrl" />
			</div>
		</div>
		<div class="flex flex-col  sm:flex-row justify-center">
			<div class="mx-3 py-3 sm:w-4/12 md:w-2/12 lg:w-2/12 mb-3" v-if=" showGallery ">
				<InteractiveImage alt="Image" preview class="rounded">
					<template #indicatoricon>
						<i class="tabler:eye w-8 h-8 text-white"></i>
					</template>
					<template #image>
						<EditButton v-if=" configcollection?.editmode  && callout.mainOutcome?.imageSrcEdit"
						class="absolute right-[0px] top-[0px] p-2 z-2 text-white bg-danger rounded hover:bg-danger-200 hover:!text-white"
						:id="callout.identifier" :type=" !isLanguageReviewMode ? 'imageattr' : 'lngReviewEdit'" 
						:icon=" isLanguageReviewMode ? 'tabler:photo-edit' : 'tabler:photo-edit'"
						:overrideURL="callout.mainOutcome?.imageSrcEdit" />

						<img :src="callout.mainOutcome?.imageSrc"
							class="img-thumbnail md:w-100% sm:w-[220px] object-contain overflow-hidden md:max-h-280px border"
							alt="image" />
					</template>
					<template #preview="slotProps">
						<div class="p-5 w-[70%] mx-auto">
							<div v-if="callout.mainOutcome?.imageTitle" class="text-mb mb-3 font-bold text-white">
								{{ callout.mainOutcome?.imageTitle }}
							</div>

							<img :src="callout.mainOutcome?.imageSrc" alt="preview" class="mx-auto max-h-[720px]"
								:style="slotProps.style" @click="slotProps.onClick" />
							<div v-if=" callout.mainOutcome.imageCopyright "
								class="text-xs mt-3 mb-3 font-bold text-white text-right">
								{{ callout.mainOutcome?.imageCopyright }}
							</div>
							<div v-if=" callout.mainOutcome.imageDescription "
								class="text-mb mt-3 mb-3 font-bold text-white">
								{{ callout.mainOutcome?.imageDescription }}
							</div>
						</div>
					</template>
				</InteractiveImage>
				<div v-if=" callout.mainOutcome?.imageCopyright "
					class="text-[0.56rem] mt-1 mb-1 text-right">
					{{ callout.mainOutcome.imageCopyright }}
				</div>
			</div>
			<div class="px-3 md:px-4 py-2 sm:w-8/12 md:w-9/12 lg:w-9/12 flex-1 relative">
				<EditButton
					class="absolute right-5px top-[5px] inline-flex items-center gap-2 transition-all rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
					v-if=" configcollection?.editmode && callout._links?.mainOutcome && !AppConfig.hideEditSelf" :id="callout.identifier"
					:type="isLanguageReviewMode ? 'lngReviewEdit' : 'listattr'"
					:overrideURL="callout._links?.mainOutcome?.href" />
				<InplaceEdit
					:collectionMode="configcollection"
					:enableCollapseSection="true"
					:extraContent="callout.mainOutcomeBl.selectHeader"
					:inputProps="[{ content: callout.mainOutcome.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
					:href="callout._links?.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true">
					<h6
						class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
						{{ callout.mainOutcome.selectHeader }}
					</h6>
				</InplaceEdit>
				<div class="full-content">
					<div class="main-text md:line-clamp-3">
						<div class="flex items-center">
							<InplaceEdit
								:collectionMode="configcollection"
								:enableCollapseSection="true"
								:extraContent="postDisplayTitle"
								:inputProps="[{ content: postTitleEditContent, propName: postTitlePropName, inputType: 'textarea' }]"
								:href="postTitleEditHref" blockTitle="Edit title"  :showAssistant="true"
								:textarea-props="{ rows: 3, class: 'min-w-[30rem]' }">
									<h4
										class="mb-2 inline-flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased">
										<EditButton
											class="!text-left"
											:id="callout.identifier"
											:buttonLabel="postDisplayTitle"
											:headerTitle="callout.packageTitle"
											:type="isRouteReadMode ? 'details' : 'print'"
											:overrideURL="learnMoreDetailsUrl"
										>
											{{ postDisplayTitle }}
										</EditButton>
									</h4>
							</InplaceEdit>
							<!-- <span class="badge badge-sm ml-2" v-if=" callout.flagMode && configcollection?.id === 'authoring' " 
							:class="{ 'badge-danger': callout.flagMode === 'au', 'badge-success': callout.flagMode === 'as' }">
								{{ callout.flagMode === 'au' ? 'Author First' : callout.flagMode === 'as' ? 'Assistant First' : callout.flagMode }}
							</span> -->

						</div>

						<div class="inline">
							<div
								class="font-sans text-sm font-normal leading-relaxed text-gray-700 antialiased mb-2 line-clamp-2 flex items-center">
								<InplaceEdit v-if="callout._links?.mainOutcomeEdit?.href && !isLanguageReviewMode"
									:collectionMode="configcollection"
									:inputProps="[{ content: callout.mainOutcome?.publishingDate, propName: 'other.publishingDate', inputType: 'datepicker' }]"
									:href="callout._links?.mainOutcomeEdit?.href" blockTitle="Edit publishing date">
									<div class="text-sm">{{ publishingDateFormated }}</div>
								</InplaceEdit>
									<div v-else class="text-sm">{{ publishingDateFormated }}</div>
								<div id="AuthorList" class="flex flex-row items-center">
									<InplaceEdit v-if="callout._links?.mainOutcomeEdit?.href && !isLanguageReviewMode" 
									:collectionMode="configcollection"
									:inputProps="[{
										content: callout.mainOutcome?.authorIdentifier, propName: 'other.authorIdentifier', inputType: 'select', selectProps: {
											optionValue: 'identifier',
											optionLabel: 'title',
											class: 'w-15rem',
											optionsCvKey: 'author',
											
										}
									}]" :href="callout._links?.mainOutcomeEdit?.href || ''" blockTitle="Edit author">
										<div class="ml-2 text-sm font-bold" v-html="callout.mainOutcome.author"> </div>
									</InplaceEdit>
									<div v-else class="ml-2 text-sm font-bold" v-html="callout.mainOutcome.author"> </div>
								</div>

							</div>
							<div
								class="flex items-center font-sans text-sm font-normal leading-relaxed text-gray-700 antialiased mb-2 line-clamp-2">
								<div id="editLeadText" class="flex items-end relative">
									<InplaceEdit
										:collectionMode="configcollection"
										:enableCollapseSection="true"
										:extraContent="postDisplayLeadText"
										:inputProps="[{ content: postLeadTextEditContent, propName: postLeadTextPropName, inputType: 'editor' }]"
										:href="postLeadTextEditHref" blockTitle="Edit leadtext" :showAssistant="true">
										<div v-html="postDisplayLeadText"></div>
									</InplaceEdit>

								</div>
							</div>

							<!-- ky button sherben per te hap detajet nepermjet routerlink -->
							
							<!-- <EditButton
								v-if="!configcollection?.hidePrintMore"
								class="flex-1 underline cursor-pointer md:text-sm text-sm"
								:id="callout.identifier"
								:buttonLabel="labels.readmode"
								:toolTipLabel="AppConfig.urls.print?.toolTipLabel"
								:overrideURL="learnMoreDetailsUrl"
								:headerTitle="callout.packageTitle"
								type="details"
							/> -->
							<EditButton v-if="!configcollection?.hidePrintMore && !configcollection?.hideLearnMore"
								class="flex-1 underline cursor-pointer md:text-sm text-sm" :class="!configcollection?.hideLearnMore ? 'ml-0' : 'ml-0'"
								:id="callout.identifier" :buttonLabel="labels.readmode" :toolTipLabel="AppConfig.urls.print?.toolTipLabel" :overrideURL="learnMoreDetailsUrl"  :headerTitle="callout.packageTitle" :type="isRouteReadMode ? 'details' : 'print'" />

						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex items-center">
			<div  class="btn-group flex pt-0 pb-3 px-3 w-full">
				<!-- <button type="button"
					class="flex flex-row hover:bg-primary-500/80 items-center rounded py-2 px-2 mt-3 text-center font-sans mr-2 text-xs font-bold transition-all bg-primary text-white block md:hidden"
					@click="showGallery = !showGallery">
					<i class="tabler:photo-up w-5 h-5"></i>
					<span class="hidden md:inline ml-1">Image</span>
				</button> -->

				<button
					class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 mt-3 text-center font-sans text-xs font-bold transition-all bg-primary text-white"  v-if="showPreQuizButton"
					:class="{ 'rounded-e mr-2': !configcollection?.editmode }" type="button"
					@click="() => { console.log('Going to:', preQuizUrl); openPreQuizDialog(); }">
					<i class="tabler:list-check w-5 h-5 md:mr-1"></i>
					<span class="hidden md:inline">{{ labels.prequiz }}</span>
				</button>
				<EditButton v-if="configcollection?.editmode && callout._links?.preQuiz?.href && showPreQuizButton"
					class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-2 text-center mr-2 mt-3 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
					:id="callout.identifier" 
					:type="isLanguageReviewMode ? 'lngReviewEdit' : 'prequiz'"								
						:overrideURL="callout._links?.preQuiz?.href" />

				<DialogModal v-if="!showOnlyQuizMode && isModalPreQuiz && showPrequziDialog" :visible="showPrequziDialog" modal :header="labels.prequiz"
					:style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
					@update:visible="showPrequziDialog = false">
					<EditButton v-if="configcollection?.editmode && callout._links?.preQuiz?.href && showPreQuizButton" class="absolute right-53px top-20px rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
						:id="callout.identifier" 
						:type="isLanguageReviewMode ? 'lngReviewEdit' : 'prequiz'"								
						:overrideURL="callout._links?.preQuiz?.href" />
					<PreQuiz v-if="hasPreQuizContent" :jsonData="callout" @close="showPrequziDialog = false"
						:overrideURL="preQuizJsonUrl" :selectedLanguage='selectedLanguage' :collectionMode="configcollection" />
				</DialogModal>
				<SliderPanel
					v-else-if="!showOnlyQuizMode && !isModalPreQuiz"
					v-model:visible="showPrequziDialog"
					:title="labels.prequiz"
					headerStyle="dark"
					size="xl"
					icon="tabler:list-check"
					:dismissable="false"
					:refreshOnClose="true"
				>
					<div class="h-full">
						<iframe
							v-if="showPrequziDialog && preQuizFrameUrl"
							:key="preQuizFrameUrl"
							:src="preQuizFrameUrl"
							class="w-full h-100vh border-0 overflow-hidden"
							style="max-height: calc(100vh - 56px);"
							:title="labels.prequiz"
						></iframe>
					</div>
				</SliderPanel>
				<button
					class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 mt-3 mr-0 text-center font-sans text-xs font-bold transition-all bg-primary text-white" v-if="showKeyMessagesButton"
					:class="{ 'rounded-e mr-2': !configcollection?.editmode }" type="button"
					@click="() => { console.log('Going to KeyMessages:', keyMessagesUrl); openKeyMessagesDialog(); }">
					<i class="tabler:list-numbers w-5 h-5 md:mr-1"></i>
					<span class="hidden md:inline">{{ labels.keymessages }}</span>
				</button>
				<EditButton class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-2 text-center mt-3 mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
				v-if="configcollection?.editmode && callout._links?.mainOutcome && callout.mainOutcome.keyMessages && showKeyMessagesButton" :id="callout.identifier" 
				:type="isLanguageReviewMode ? 'lngReviewEdit' : 'listattr'"
				:overrideURL="callout._links?.mainOutcome?.href" />

				<DialogModal v-if="!showOnlyQuizMode && isModalKeyMessage" :visible="showKeymessagesDialog" modal :header="labels.keymessages"
					:style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
					@update:visible="showKeymessagesDialog = false">
					<div v-if="isLoadingKeyMessages" class="flex items-center justify-center py-10">
						<i class="tabler:loader-2 w-8 h-8 animate-spin text-primary"></i>
						<span class="ml-2">Loading...</span>
					</div>
					<div v-else-if="hasKeyMessagesContent" id="editKeyMessagges" class="flex items-end">
						<InplaceEdit
							:inputProps="[{ content: keyMessagesContent, propName: 'other.keyMessages', inputType: 'editor' }]"
							:enableCollapseSection="true"
							:extraContent="callout.mainOutcomeBl.keyMessages"
							:href="keyMessagesEditUrl" blockTitle="Edit key Messages"  :showAssistant="true">
							<div id="editKeyMessaggesWrapper" v-html="keyMessagesContent"></div>
						</InplaceEdit>
					</div>
				</DialogModal>
				<SliderPanel
					v-else-if="!showOnlyQuizMode"
					v-model:visible="showKeymessagesDialog"
					:title="labels.keymessages"
					headerStyle="dark"
					size="xl"
					icon="tabler:list-numbers"
					:dismissable="false"
					:refreshOnClose="true"
				>
					<div class="h-full">
						<iframe
							v-if="showKeymessagesDialog && keyMessagesFrameUrl && hasKeyMessagesContent"
							:key="keyMessagesFrameUrl"
							:src="keyMessagesFrameUrl"
							class="w-full h-100vh border-0 overflow-hidden"
							style="max-height: calc(100vh - 56px);"
							:title="labels.keymessages"
						></iframe>
					</div>
				</SliderPanel>


				<template v-if=" !isTextOnlyOutput && !showOnlyQuizMode ">
					<PlayerButton v-if="showReadToMeButton && callout.file_url"
						:file_url="playerFileUrl"
						class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 mt-3 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
						:class="{ 'rounded-e mr-2': !configcollection?.editmode }"
						:language="selectedLanguage" :isPlaying="isPlaying"
						@togglePlayback="emit( 'play', callout.identifier )" />

						<EditButton 
							v-if="configcollection?.editmode && callout.file_url && showReadToMeButton"
							class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-2 mt-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							
							:id="callout.identifier" 
							:type="isLanguageReviewMode ? 'lngReviewEdit' : 'podcast'"								
							:overrideURL="callout._links?.podcastSlideshowConversations?.href"
						/>

					<EditButton v-if="showPresentationButton && hasPresentationContent"
						class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 text-center mt-3 font-sans text-xs font-bold transition-all bg-primary text-white" :class="[ configcollection?.hidePresentationButton ? 'ml-2' : 'ml-0', { 'rounded-e': !configcollection?.editmode }]"
						:id="callout.identifier" :buttonLabel="`${labels.presentation}`" :toolTipLabel="`${labels.presentation}`"  :headerTitle="postDisplayTitle" type="slideshow" />

						<EditButton
							v-if="configcollection?.editmode && showPresentationButton && presentationEditUrl"
							class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-2 text-center font-sans mt-3 text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							:id="callout.identifier"
							:type="isLanguageReviewMode ? 'lngReviewEdit' : 'slideshowEdit'"
							:overrideURL="presentationEditUrl"
						/>
				</template>
					<button
						class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 mt-3 text-center font-sans text-xs font-bold transition-all bg-primary text-white ml-2"
						v-if="showPostQuizButton"
						:class="{ 'rounded-e mr-2': !configcollection?.editmode }" type="button"
						@click="() => { console.log('Going to PostQuiz:', postQuizUrl); openPostQuizDialog(); }">
						<i class="tabler:list-check w-5 h-5 md:mr-1"></i>
						<span class="hidden md:inline">{{ labels.postquiz }}</span>
					</button>
					<EditButton v-if="configcollection?.editmode && callout._links?.postQuiz?.href && showPostQuizButton"
						class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 mt-3 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
						:id="callout.identifier" 
						:type="isLanguageReviewMode ? 'lngReviewEdit' : 'postquiz'"
						:overrideURL="callout._links?.postQuiz?.href" />

					<DialogModal v-if="!showOnlyAssessment && isModalPostQuiz && showPostquizDialog" :visible="showPostquizDialog" modal :header="labels.postquiz"
						:style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
						@update:visible="showPostquizDialog = false">

						<EditButton v-if="configcollection?.editmode && callout._links?.postQuiz?.href && showPostQuizButton" class="absolute right-53px top-20px rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white" :id="callout.identifier" 
						:type="isLanguageReviewMode ? 'lngReviewEdit' : 'postquiz'"								
						:overrideURL="callout._links?.postQuiz?.href" />
						<PostQuiz
							v-if="hasPostQuizContent"
							:jsonData="callout" :overrideURL="postQuizJsonUrl"  :collectionMode="configcollection" :selectedLanguage="selectedLanguage" @close="showPostquizDialog = false" />
					</DialogModal>
					<SliderPanel
						v-else-if="!showOnlyAssessment && !isModalPostQuiz"
						v-model:visible="showPostquizDialog"
						:title="labels.postquiz"
						headerStyle="dark"
						size="xl"
						icon="tabler:list-check"
						:dismissable="false"
						:refreshOnClose="true"
					>
						<div class="h-full">
							<iframe
								v-if="showPostquizDialog && postQuizFrameUrl && hasPostQuizContent"
								:key="postQuizFrameUrl"
								:src="postQuizFrameUrl"
								class="w-full h-100vh border-0 overflow-hidden"
								style="max-height: calc(100vh - 56px);"
								:title="labels.postquiz"
							></iframe>
							<div v-else class="h-full overflow-y-auto p-4">
								<PostQuiz
									v-if="hasPostQuizContent"
									:jsonData="callout" :overrideURL="postQuizJsonUrl"  :collectionMode="configcollection" :selectedLanguage="selectedLanguage" @close="showPostquizDialog = false" />
							</div>
						</div>
					</SliderPanel>
					<EditButton
						v-if="showConfiguredAssessmentButton"
						class="rounded-s flex flex-row items-center py-2 px-2 mt-3 text-center font-sans text-xs font-bold transition-all text-white"
						:class="[assessmentButtonClass, { 'rounded-e mr-2': !configcollection?.editmode }]"
						:id="callout.identifier"
						type="assessment"
						:buttonLabel="assessmentButtonLabel"
						:toolTipLabel="assessmentToolTipLabel"
						:overrideURL="configuredAssessmentUrl"
						:headerTitle="assessmentPanelTitle"
					/>
					<button
						v-else-if="showLocalAssessmentButton"
						class="rounded-s flex flex-row items-center py-2 px-2 mt-3 text-center font-sans text-xs font-bold transition-all text-white"
						:class="[assessmentButtonClass, { 'rounded-e mr-2': !configcollection?.editmode }]"
						type="button"
						v-tooltip.bottom="assessmentToolTipLabel"
						@click="openAssessmentDialog"
					>
						<i class="tabler:clipboard-check w-5 h-5 md:mr-1"></i>
						<span class="hidden md:inline">{{ assessmentButtonLabel }}</span>
					</button>

					<EditButton
						v-if="isAssessmentButtonEnabled && configcollection?.editmode && assessmentBaseUrl"
						class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-2 text-center mt-3 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
						:id="callout.identifier"
						:type="isLanguageReviewMode ? 'lngReviewEdit' : 'assessmentEdit'"
						:overrideURL="assessmentBaseUrl"
						:headerTitle="assessmentPanelTitle"
					/>

					<DialogModal
						v-if="showLocalAssessmentButton && isModalAssessment"
						:visible="showAssessmentDialog"
						modal
						:header="assessmentPanelTitle"
						:style="{ width: '40rem' }"
						:breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
						@update:visible="showAssessmentDialog = false"
					>
						<EditButton
							v-if="configcollection?.editmode && assessmentBaseUrl"
							class="absolute right-53px top-20px rounded hover:bg-secondary-500/80 items-center py-2 px-2 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							:id="callout.identifier"
							:type="isLanguageReviewMode ? 'lngReviewEdit' : 'assessmentEdit'"
							:overrideURL="assessmentBaseUrl"
							:headerTitle="assessmentPanelTitle"
						/>
						<Assessment
							:jsonData="callout"
							:collectionMode="configcollection?.id"
							@close="showAssessmentDialog = false"
							:overrideURL="assessmentQuizUrl"
							:selectedLanguage="selectedLanguage"
						/>
					</DialogModal>
					<SliderPanel
						v-else-if="showLocalAssessmentButton"
						v-model:visible="showAssessmentDialog"
						:title="assessmentPanelTitle"
						headerStyle="dark"
						size="xl"
						icon="tabler:clipboard-check"
						:dismissable="false"
					>
						<div class="h-full overflow-y-auto p-4">
							<div v-if="configcollection?.editmode && assessmentBaseUrl" class="mb-3 flex justify-end">
								<EditButton
									class="rounded hover:bg-secondary-500/80 items-center py-2 px-2 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
									:id="callout.identifier"
									:type="isLanguageReviewMode ? 'lngReviewEdit' : 'assessmentEdit'"
									:overrideURL="assessmentBaseUrl"
									:headerTitle="assessmentPanelTitle"
								/>
							</div>
							<Assessment
								:jsonData="callout"
								:collectionMode="configcollection?.id"
								@close="showAssessmentDialog = false"
								:overrideURL="assessmentQuizUrl"
								:selectedLanguage="selectedLanguage"
							/>
						</div>
					</SliderPanel>

			<div v-if="!isReadCallAssistantButtonHidden || showFeedbackButton" class="gap-2 mt-3 flex ml-auto">
				<EditButton
					class="rounded hover:bg-secondary-500/80 items-center py-2 px-2 text-center font-sans text-xs font-bold hover:text-success-500 transition-all bg-secondary !text-white"
					v-if="!isReadCallAssistantButtonHidden"
					:modal="isModalCallAssistant"
					:id="callout.identifier" type="readCallAssistantButton"
					:overrideURL="callout._links?.helpSupportAssistantLink?.href"
					:headerTitle="postDisplayTitle"
					:buttonLabel="AppConfig.urls.assistantModeButtons?.readCallAssistantButton.buttonLabel"
					:toolTipLabel="AppConfig.urls.assistantModeButtons?.readCallAssistantButton.toolTipLabel"
						/>
				<!-- menyra e vjeter e feedback -->
				<EditButton
					class="rounded flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
					v-if="showFeedbackButton"
					:modal="isModalFeedback"
					:id="callout.identifier" type="feedback"
					:buttonLabel="AppConfig.urls.feedback?.buttonLabel"
					:toolTipLabel="AppConfig.urls.feedback?.toolTipLabel"
					@click="console.log('Going to:', feedbackUrl)"
					:overrideURL="feedbackUrl" />

				<!-- <EditButton
					class="rounded flex flex-row hover:bg-primary-500/80 items-center ml-2 py-2 px-2 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
					v-if="!configcollection?.hideFeedbackButton && AppConfig.urls.notification?.url"
					:id="callout.identifier" type="notification"
					:buttonLabel="AppConfig.urls.notification?.buttonLabel"
					:toolTipLabel="AppConfig.urls.notification?.toolTipLabel"
					@click="console.log('Going to:', notificationUrl)"
					:overrideURL="notificationUrl" /> -->
			</div>
			</div>									
					
					<!-- menyra e re e feedback -->
					<!-- <button
						class="rounded flex flex-row hover:bg-primary-500/80 mt-3 items-center ml-2 py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
						v-if="showFeedbackButton"
						@click="goToFeedbackPage"
					>
						<i class="tabler:message w-5 h-5 md:mr-1"></i>
						<span>Feedback</span>
					</button> -->
			
		</div>

		<div v-if="!configcollection?.hidePostFooter" class="flex items-center p-3 border-t border-gray-200 flex-wrap">
				<EditButton v-if=" !configcollection?.hideWorkflowStates && configcollection?.editmode && callout.assistantStatus !== 'in progress' && callout._links?.personalAssistantProcessingLink?.href !== '' " class="flex items-center gap-2 mr-2 border rounded px-2 py-[6.5px] border-danger text-danger"
					:id="callout.identifier" type="assistantMode"
					:overrideURL="callout._links?.personalAssistantProcessingLink?.href"
					:buttonLabel="callout.workflowState || 'Workflow State'"
					:toolTipLabel="`Workflow Step: ${callout.workflowState }`"
				/>
				<AssistantDropdown
					v-if="!configcollection?.hiddeAssistantComponent" 
					:callout="callout"
					:AppConfig="AppConfig"
					:headerTitle="postDisplayTitle"
					:showhelpSupportAssistantButton="showhelpSupportAssistantButton"
					:showassistantComplainceButton="showassistantComplainceButton"
					:showassistantReportButton="showassistantReportButton"
					:showFeedbackassistantButton="showFeedbackassistantButton"
					:showCallAssistantButton="showCallAssistantButton"
				/>

			<div class="ml-auto flex items-center flex-wrap md:flex-nowrap gap-2">
				<!-- <EditButton v-if=" configcollection?.editmode && callout.assistantStatus === 'in progress' && callout._links?.assistantProcessingLink?.href !=='' " class="flex items-center gap-2 mr-2 border rounded px-2 py-[6.5px] border-danger text-danger"
				:id="callout.identifier" type="processingassistantMode"
				:overrideURL="callout._links?.assistantProcessingLink?.href"
				/> -->
				<div v-if="!configcollection?.hideAuthoringStatus">
				<AuthoringStatus
					v-if="callout.assistantStatus !== 'in progress'"
					v-tooltip.top="'Package Authoring Status'"
					:class="{ 'disabled' : configcollection?.disabledAuthoringStatus }"
					:uid="callout.identifier"
					:jsonData="callout"
					:optionLabel="callout.authoringStatusCode"
					:statusOptions="authoringStatusOptions"
					:optionValue="authoringStatus"
					:key="callout.identifier"
					@statusChange="authoringStatusChange"
				/>
				</div>

				<div v-if="!configcollection?.hideReviewStatus">
				<ReviewStatus
					v-if="callout.assistantStatus !== 'in progress'"
					v-tooltip.top="'Package Review Status'"
					:class="{ 'disabled' :  configcollection?.disabledReviewStatus }"
					:uid="callout.identifier"
					:jsonData="callout"
					:optionLabel="callout.reviewStatusCode"
					:reviewStatusOptions="reviewStatusOptions"
					:optionValue="reviewStatus"
					:key="callout.identifier"
					@statusChange="reviewStatusChange"
				/>
				</div>
				<div v-if="!configcollection?.hidePublishingStatus">
				<PublishingStatus v-if="callout.assistantStatus !== 'in progress'" v-tooltip.top="'Package Publishing Status'" :uid="callout.identifier"
					:jsonData="callout" :optionLabel="callout.publishingStatusCode" :lng="selectedLanguage"
					:class="{ 'disabled' : configcollection?.disabledPublishingStatus }"
					:statusOptions="publishingStatusOptions"
					:optionValue="callout.publishingStatusCode" :key="callout.identifier"
					@statusChange="publishingStatusChange" />
				</div>
				<NotificationDropdown
					v-if="!configcollection?.hiddeNotificationList" 
					:callout="callout"
					:AppConfig="AppConfig"
					:configcollection="configcollection"
					:class="{ 'disabled' : configcollection?.disableNotify }"
					:selectedLanguage="selectedLanguage"
					:hiddeNotifyReviewers="!configcollection?.hiddeNotifyReviewers"
					:hiddeNotifyLanguageReviewers="!configcollection?.hiddeNotifyLanguageReviewers"
					:hiddeNotifyEditorPublisher="!configcollection?.hiddeNotifyEditorPublisher"
					:hiddeNotifyAudience="!configcollection?.hiddeNotifyAudience"
					:hiddeProductionTeam="!configcollection?.hiddeProductionTeam"
				/>

			</div>
		
		</div>

	</div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import { DateTime } from "luxon";

import { useAppConfig } from '@/composables/useAppConfig';
import type { Callout, LanguageCodes, configCollectionMode } from '@/types'
import { messages } from '@/assets/language';
import EditButton from '@/components/EditButton.vue'
import PreQuiz from '@/components/PreQuiz.vue'
import Assessment from '@/components/Assessment.vue'
import PostQuiz from '@/components/PostQuiz.vue'
import AssistantDropdown from '@/components/AssistantDropdown.vue';
import PlayerButton from '@/components/PlayerButton.vue'
import AuthoringStatus from '@/components/AuthoringStatus.vue'
import ReviewStatus from './ReviewStatus.vue';
import PublishingStatus from '@/components/PublishingStatus.vue'
import InplaceEdit from '@/components/InplaceEdit/InplaceEdit.vue'
import NotificationDropdown from '@/components/NotificationDropdown.vue';
import SliderPanel from '@/components/SidebarPanel/SidebarPanel.vue'
import { useAppStore } from '@/stores/app-store'
import { readAssessmentMetadataFromCallout } from '@/utils/assessmentMetadata'
import { appendFeedbackContext, resolveFeedbackBaseUrl } from '@/utils/feedbackUrl'
import { resolveAssessmentButtonLabel } from '@/utils/assessmentLabel'
import { hasPackageTargetAudienceIdentifier } from '@/utils/targetAudience'

const AppConfig = useAppConfig()
const { currentLng, currentCollectionMode, currentTestyourself, currentPAGE_REQ_ID } = useAppStore()


const props = withDefaults( defineProps<{
	callout: Callout;
	configcollection: configCollectionMode | null
	isTextOnlyOutput?: boolean
	isPlaying?: boolean
	isEditMode?: boolean
	hideActions?: boolean
	selectedLanguage?: LanguageCodes
	authoringStatusOptions?: Array<{ identifier: string; title: string; disabled?: boolean }>;
	reviewStatusOptions?: Array<{ identifier: string; title: string; disabled?: boolean }>;
	publishingStatusOptions?: Array<{ identifier: string; title: string }>;
}>(), {
	isTextOnlyOutput: false,
	isPlaying: false,
	isEditMode: false,
	hideActions: false,
	selectedLanguage: 'de'
} )

const emit = defineEmits<{
	play: [Callout['identifier']]
	toPresentation: [Callout['identifier']]
	reviewStatusChange: [Callout['reviewStatusCode']]
	authoringStatusChange: [Callout['authoringStatusCode']]
	publishingStatusChange: [Callout['publishingStatusCode']]
	titleUpdate: ['title-update']
	delete:[string]
	statusesChange: [{
		id: Callout['identifier'],
		authoring: Callout['authoringStatusCode'],
		review: Callout['reviewStatusCode']
	}]
}>()

const authoringStatus = ref<Callout['authoringStatusCode']>(props.callout.authoringStatusCode)
const reviewStatus    = ref<Callout['reviewStatusCode']>(props.callout.reviewStatusCode)

const authoringDisabled = ref(false)
const reviewDisabled    = ref(false)

// sinkronizo lokalet nëse prindi (ListView) sjell callout të ri
watch(() => props.callout.authoringStatusCode, (v) => {
  if (v && v !== authoringStatus.value) {
    authoringStatus.value = v
    // Authoring -> Review, 1:1 si rregullat e tua
    if (v === "n")      { reviewStatus.value = "n"; reviewDisabled.value = false }
    else if (v === "d") { reviewStatus.value = "n"; reviewDisabled.value = false }
    else if (v === "f") { reviewStatus.value = "d"; reviewDisabled.value = false }
  }
})
watch(() => props.callout.reviewStatusCode, (v) => {
  if (v && v !== reviewStatus.value) {
    reviewStatus.value = v
    // Review -> Authoring, 1:1 si rregullat e tua
    if      (v === "f" || v === "e") { authoringStatus.value = "f"; authoringDisabled.value = false }
    else if (v === "d")              { authoringStatus.value = "f"; authoringDisabled.value = false }
    else if (v === "n")              { authoringStatus.value = "n"; authoringDisabled.value = false }
  }
})

async function authoringStatusChange ( newStatus: Callout['authoringStatusCode'] ) {
	authoringStatus.value = newStatus

	if (newStatus === "n") {
		reviewStatus.value = "n"
		reviewDisabled.value = false
	}
	else if (newStatus === "d") {
		reviewStatus.value = "n"
		reviewDisabled.value = false
	}
	else if (newStatus === "f") {
		reviewStatus.value = "d"   // finalized -> draft
		reviewDisabled.value = false
	}

	emit( 'authoringStatusChange', newStatus )

	// (opsionale) njofto ListView për refresh ose update optimist
	await nextTick()
	emit('statusesChange', {
		id: props.callout.identifier,
		authoring: authoringStatus.value,
		review: reviewStatus.value
	})
}

// Review -> Authoring (thirret nga @statusChange i ReviewStatus)
async function reviewStatusChange ( newStatus: Callout['reviewStatusCode'] ) {
	reviewStatus.value = newStatus

	if (newStatus === "f" || newStatus === "e") {
		authoringStatus.value = "f"
		authoringDisabled.value = false
	}
	else if (newStatus === "d") {
		authoringStatus.value = "f"
		authoringDisabled.value = false
	}
	else if (newStatus === "n") {
		authoringStatus.value = "d"
		authoringDisabled.value = false
	}

	emit('reviewStatusChange', newStatus)

	await nextTick()
	emit('statusesChange', {
		id: props.callout.identifier,
		authoring: authoringStatus.value,
		review: reviewStatus.value,
	})
}

// Publishing mbetet i pandryshuar
async function publishingStatusChange ( newStatus: Callout['publishingStatusCode'] ) {
	emit('publishingStatusChange', newStatus)

	await nextTick()
	emit('statusesChange', {
		id: props.callout.identifier,
		authoring: authoringStatus.value,
		review: reviewStatus.value,
	})
}

// Inicializim – ekuivalent i initializeStatusLogic()
onMounted(() => {
	const a = authoringStatus.value
	const r = reviewStatus.value

	// disable opsionin "n" në arrays (PrimeVue e respekton .disabled)
	props.authoringStatusOptions?.forEach(o => { if (o.identifier === "n") (o as any).disabled = false })
	props.reviewStatusOptions?.forEach(o => { if (o.identifier === "n") (o as any).disabled = false })

	// rasti special: authoring=d & review=n -> disable review
	if (a === "d" && r === "n") reviewDisabled.value = false

	// nëse të dyja janë "n" -> disable të dyja
	if (a === "n" && r === "n") {
		authoringDisabled.value = false
		reviewDisabled.value = false
	}
})
/* ==================== fund seksionit të lidhjes ==================== */

const deleteItem = (url: string) => {
//   console.log('Deleting item:', url);
  emit('delete', url);
};

const isModalFeedback = computed(() => AppConfig.urls.feedback?.modal === true)
const isModalPreQuiz = computed(() => AppConfig.urls.prequiz?.modal === true)
const isModalAssessment = computed(() => AppConfig.urls.assessment?.modal === true)
const isModalPostQuiz = computed(() => AppConfig.urls.postquiz?.modal === true)
const isModalKeyMessage = computed(() => AppConfig.urls.keymessage?.modal === true)
const isModalCallAssistant = computed(() => AppConfig.urls.assistantModeButtons?.callAssistantButton.modal === true)
const resolveOpenMode = (value: string | null | undefined): 'modal' | 'route' =>
	value === 'route' ? 'route' : 'modal'
const isRouteReadMode = computed(() => resolveOpenMode(AppConfig.urls.print?.openMode) === 'route')
const isEnabledFlag = (value: unknown): boolean =>
	['y', 'yes', 'true', '1'].includes(String(value ?? '').trim().toLowerCase())
const isDisabledFlag = (value: unknown): boolean =>
	['n', 'no', 'false', '0'].includes(String(value ?? '').trim().toLowerCase())
const isButtonHidden = (value: unknown): boolean => isEnabledFlag(value)
const isReadCallAssistantButtonHidden = computed(() =>
	isButtonHidden(props.configcollection?.hideReadCallAssistantButton)
)
const isFeedbackButtonHidden = computed(() =>
	isButtonHidden(props.configcollection?.hideFeedbackButton)
)
const isFeedbackEnabled = computed(() => AppConfig.urls.feedback?.enabled === true)
const hasHsPackageTargetAudience = computed(() => hasPackageTargetAudienceIdentifier(props.callout, 'hs'))
const hasFeedbackListUrl = computed(() =>
	isFeedbackEnabled.value && String(AppConfig.urls.feedback?.listUrl ?? '').trim() !== ''
)
const isAssessmentButtonEnabled = computed(() =>
	isEnabledFlag(AppConfig.urls.assessment?.enabled)
)
const showPreQuizButton = computed(() =>
	!isButtonHidden(props.configcollection?.hidePreQuizButton) &&
	!showOnlyQuizMode.value
)
const showKeyMessagesButton = computed(() =>
	!isButtonHidden(props.configcollection?.hideKeyMessagesButton) &&
	!showOnlyQuizMode.value
)
const showReadToMeButton = computed(() =>
	!isButtonHidden(props.configcollection?.hideReadittomeButton) &&
	!props.isTextOnlyOutput &&
	!showOnlyQuizMode.value &&
	Boolean(props.callout.file_url)
)
const showPresentationButton = computed(() =>
	!isButtonHidden(props.configcollection?.hidePresentationButton) &&
	!props.isTextOnlyOutput &&
	!showOnlyQuizMode.value
)
const showPostQuizButton = computed(() =>
	!isButtonHidden(props.configcollection?.hidePostQuizButton) &&
	!showOnlyAssessment.value
)
const isLanguageReviewMode = computed(() => {
	const mode = String(props.configcollection?.id ?? '')
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '_')

	return ['language_review'].includes(mode)
})
const showOnlyAssessment = computed(() =>
	isEnabledFlag(props.configcollection?.showOnlyAssessment) ||
	isEnabledFlag(AppConfig.showOnlyAssessment)
)
const showOnlyPostQuiz = computed(() =>
	!showOnlyAssessment.value && (
		isEnabledFlag(currentTestyourself.value) ||
		Boolean(props.configcollection?.showOnlyPostquiz) ||
		Boolean(AppConfig.showOnlyPostquiz)
	)
)
const showOnlyQuizMode = computed(() => showOnlyPostQuiz.value || showOnlyAssessment.value)

const isAssessmentMetadataPreferred = computed(() =>
	isEnabledFlag(currentTestyourself.value)
)

const fetchedAssessmentMetadata = ref<{ title: string; leadText: string }>({
	title: '',
	leadText: ''
})

const resetFetchedAssessmentMetadata = () => {
	fetchedAssessmentMetadata.value = {
		title: '',
		leadText: ''
	}
}

const inlineAssessmentMetadata = computed(() => readAssessmentMetadataFromCallout(props.callout))

const assessmentMetadata = computed(() => ({
	title: String(
		fetchedAssessmentMetadata.value.title ||
		inlineAssessmentMetadata.value.title ||
		''
	).trim(),
	leadText: String(
		fetchedAssessmentMetadata.value.leadText ||
		inlineAssessmentMetadata.value.leadText ||
		''
	).trim()
}))

const postDisplayTitle = computed(() => {
	if (isAssessmentMetadataPreferred.value && assessmentMetadata.value.title) {
		return assessmentMetadata.value.title
	}
	return String(props.callout.mainOutcome?.title ?? '').trim()
})

const postDisplayLeadText = computed(() => {
	if (isAssessmentMetadataPreferred.value && assessmentMetadata.value.leadText) {
		return assessmentMetadata.value.leadText
	}
	return String(props.callout.mainOutcome?.leadText ?? '').trim()
})

const assessmentMetadataEditHref = computed(() => {
	const links = (props.callout as any)?._links ?? {}
	return String(links?.assessment?.href ?? links?.assessmentQuiz?.href ?? '').trim()
})

const postTitleEditHref = computed(() => {
	if (isAssessmentMetadataPreferred.value && assessmentMetadataEditHref.value) {
		return assessmentMetadataEditHref.value
	}
	return props.callout._links?.mainOutcomeEdit?.href ?? ''
})

const postLeadTextEditHref = computed(() => {
	if (isAssessmentMetadataPreferred.value && assessmentMetadataEditHref.value) {
		return assessmentMetadataEditHref.value
	}
	return props.callout._links?.mainOutcomeEdit?.href ?? ''
})

const postTitlePropName = computed(() => 'title')

const postLeadTextPropName = computed(() =>
	isAssessmentMetadataPreferred.value ? 'leadText' : 'other.leadText'
)

const postTitleEditContent = computed(() =>
	isAssessmentMetadataPreferred.value
		? (assessmentMetadata.value.title || String(props.callout.mainOutcome?.title ?? '').trim())
		: String(props.callout.mainOutcome?.title ?? '').trim()
)

const postLeadTextEditContent = computed(() =>
	isAssessmentMetadataPreferred.value
		? (assessmentMetadata.value.leadText || String(props.callout.mainOutcome?.leadText ?? '').trim())
		: String(props.callout.mainOutcome?.leadText ?? '').trim()
)

const showassistantComplainceButton = computed(() => AppConfig.urls.assistantModeButtons?.complainceButton.enabled === true && AppConfig.urls.assistantModeButtons?.complainceButton.complainceAssistantLink !== '')
const showhelpSupportAssistantButton = computed(() => AppConfig.urls.assistantModeButtons?.helpSupportAssistantButton.enabled === true)
const showassistantReportButton = computed(() => AppConfig.urls.assistantModeButtons?.reportButton.enabled === true && AppConfig.urls.assistantModeButtons?.reportButton.reportAssistantLink !== '')
const showFeedbackassistantButton = computed(() => AppConfig.urls.assistantModeButtons?.feedbackAssistantButton.enabled === true)
const showCallAssistantButton = computed(() => AppConfig.urls.assistantModeButtons?.callAssistantButton.enabled === true && 
AppConfig.urls.assistantModeButtons?.callAssistantButton?.url !== '')

const publishingDateFormated = computed(() => {
	const publishingDate = props.callout?.mainOutcome?.publishingDate;
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};
	const formatDate = (date: Date) => {
		return new Intl.DateTimeFormat('en-GB', options).format(date);
	};
	if (!publishingDate) {
		return formatDate(new Date());
	}
	const dateTime = DateTime.fromISO(publishingDate);
	if (!dateTime.isValid) {
		return formatDate(new Date());
	}
	return formatDate(dateTime.toJSDate());
});

const showPrequziDialog = ref( false )
const showAssessmentDialog = ref( false )
const showPostquizDialog = ref( false )
const showKeymessagesDialog = ref( false )
const showGallery = ref( true )

// KeyMessages fetch state
const isLoadingKeyMessages = ref(false)
const fetchedKeyMessages = ref<string | null>(null)

const keyMessagesContent = computed(() => {
	return fetchedKeyMessages.value ?? props.callout.mainOutcome.keyMessages
})

const hasKeyMessagesContent = computed(() => String(keyMessagesContent.value ?? '').trim().length > 0)

const presentationViewUrl = computed(() =>
	String(props.callout._links?.podcastSlideshowEdit?.href ?? '').trim()
)
const presentationEditUrl = computed(() =>
	String(props.callout._links?.podcastSlideshow?.href ?? '').trim()
)
const hasPresentationSlides = computed(() =>
	Array.isArray((props.callout as any)?.podcastSlideshow) &&
	(props.callout as any).podcastSlideshow.length > 0
)
const hasPresentationContent = computed(() =>
	presentationViewUrl.value !== '' ||
	presentationEditUrl.value !== '' ||
	hasPresentationSlides.value
)

const hasInlineQuestions = (source: unknown): boolean => {
	if (Array.isArray(source)) {
		return source.some(hasInlineQuestions)
	}

	if (!source || typeof source !== 'object') {
		return false
	}

	const record = source as Record<string, any>
	if (record.question !== undefined || Array.isArray(record.answers)) {
		return true
	}

	if (Array.isArray(record.questions) && record.questions.length > 0) {
		return true
	}

	return ['preQuiz', 'postQuiz', 'assessment', 'assessmentQuiz', 'data', 'items', 'children'].some((key) =>
		hasInlineQuestions(record[key])
	)
}

const parseKeyMessagesResponse = (responseText: string) => {
	const trimmedText = responseText.trim().replace(/^\uFEFF/, '')
	const parsed = JSON.parse(trimmedText)
	return typeof parsed === 'string' ? JSON.parse(parsed.trim().replace(/^\uFEFF/, '')) : parsed
}

const resolveKeyMessagesContent = (data: any) =>
	String(
		data?.other?.keyMessages ??
		data?.mainOutcome?.keyMessages ??
		data?.keyMessages ??
		data?.other?.keymessages ??
		''
	).trim()

const stopInlineAudio = () => {
	window.dispatchEvent(new CustomEvent('stop-inline-audio'));
};

const openPreQuizDialog = () => {
	stopInlineAudio();
	showPrequziDialog.value = true;
};

const openAssessmentDialog = () => {
	stopInlineAudio();
	showAssessmentDialog.value = true;
};

const openPostQuizDialog = () => {
	stopInlineAudio();
	showPostquizDialog.value = true;
};

const openKeyMessagesDialog = async () => {
	stopInlineAudio();
	showKeymessagesDialog.value = true;

	if (!isModalKeyMessage.value) {
		return
	}

	if (keyMessagesUrl.value) {
		isLoadingKeyMessages.value = true;
		try {
			console.log('[KeyMessages] Fetching from:', keyMessagesUrl.value);
			const response = await fetch(keyMessagesUrl.value, {
				method: 'GET',
				credentials: 'include',
				headers: { Accept: 'application/json' },
			});

			if (!response.ok) {
				console.log('[KeyMessages] HTTP error, using existing data:', response.status);
				return;
			}

			const data = parseKeyMessagesResponse(await response.text());
			console.log('[KeyMessages] Fetched data:', data);

			const resolvedContent = resolveKeyMessagesContent(data)
			if (resolvedContent) {
				fetchedKeyMessages.value = resolvedContent;
			} else {
				console.log('[KeyMessages] Invalid response structure, using existing data');
			}
		} catch (error) {
			console.log('[KeyMessages] Fetch error, using existing data:', error);
		} finally {
			isLoadingKeyMessages.value = false;
		}
	}
};

const labels = computed( () => messages[props.selectedLanguage] );
const feedbackBaseUrl = computed(() =>
  resolveFeedbackBaseUrl(AppConfig.urls.feedback, props.selectedLanguage)
)
const showFeedbackButton = computed(() =>
	isFeedbackEnabled.value && hasHsPackageTargetAudience.value && !isFeedbackButtonHidden.value && Boolean(feedbackBaseUrl.value)
)

const feedbackUrl = computed(() => {
  const baseUrl = feedbackBaseUrl.value
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const feedbacktype = props.configcollection?.feedbacktype ?? "AJS"
  const fullUrl = appendFeedbackContext(baseUrl, {
    packageId: id,
    packageLng,
    sourceReqId: sourcereqid,
    feedbackType: feedbacktype,
  })
  //console.log("[Feedback URL]", fullUrl)
  return fullUrl
})

const feedbackListUrl = computed(() => {
  const baseUrl = AppConfig.urls.feedback?.listUrl ?? ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const feedbacktype = props.configcollection?.feedbacktype ?? "AJS"
  const separator = baseUrl.includes("?") ? "&" : "?"
  const fullUrl = `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}&feedbacktype=${feedbacktype}`
  //console.log("[Feedback URL]", fullUrl)
  return fullUrl
})

const buildAssessmentContextUrl = (baseUrl: string) => {
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
}

const configuredAssessmentUrl = computed(() =>
  buildAssessmentContextUrl(String(AppConfig.urls.assessment?.url ?? "").trim())
)

const assessmentButtonLabel = computed(() =>
  resolveAssessmentButtonLabel({
    typeOfOutcome: AppConfig.urls.assessment?.typeofoutcome,
    configuredLabel: AppConfig.urls.assessment?.buttonLabel,
    labels: labels.value
  })
)

const assessmentToolTipLabel = computed(() =>
  String(AppConfig.urls.assessment?.toolTipLabel || assessmentButtonLabel.value)
)

const assessmentButtonClass = computed(() => {
	const buttonClass = String(AppConfig.urls.assessment?.buttonClass || '').trim()
	const key = buttonClass.replace(/^bg-/, '')
	const classMap: Record<string, string> = {
		primary: 'bg-primary hover:bg-primary-500/80',
		secondary: 'bg-secondary hover:bg-secondary-500/80',
		danger: 'bg-danger hover:bg-danger-500/80',
		success: 'bg-success hover:bg-success-500/80',
		warning: 'bg-warning hover:bg-warning-500/80',
		info: 'bg-info hover:bg-info-500/80',
	}

	return classMap[key] || buttonClass || classMap.primary
})

const assessmentPanelTitle = computed(() =>
  String(postDisplayTitle.value || assessmentButtonLabel.value)
)

const preQuizUrl = computed(() => {
  const baseUrl = props.callout._links?.preQuiz?.href ?? ""
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const resolveApiUrl = (rawUrl: string) => {
  const apiBase = String(AppConfig.urls.getList ?? "").trim()
  try {
    const apiOrigin = apiBase ? new URL(apiBase, window.location.origin).origin : window.location.origin
    return new URL(rawUrl, apiOrigin)
  } catch {
    return null
  }
}

const extractPackageIdFromUrl = (url: URL) => {
  const match = url.pathname.match(/\/wi-package\/([^/]+)/)
  return match?.[1] ?? ""
}

const preQuizEditIframeUrl = computed(() => {
  const baseUrl = props.callout._links?.preQuizEdit?.href ?? ""
  if (!baseUrl) return ""
  const url = resolveApiUrl(baseUrl)
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""

  if (url) {
    const packageId = extractPackageIdFromUrl(url) || props.callout.identifier || ""
    url.searchParams.set("json", "y")
    url.searchParams.set("package", "SAT")
    url.searchParams.set("packageid", packageId)
    url.searchParams.set("packageLng", packageLng)
    url.searchParams.set("sourcereqid", sourcereqid)
    return url.toString()
  }

  const id = props.callout.identifier ?? ""
  const urlWithJson = /[?&]json=/.test(baseUrl)
    ? baseUrl.replace(/([?&]json=)[^&#]*/, "$1y")
    : `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}json=y`
  const separator = urlWithJson.includes("?") ? "&" : "?"
  return `${urlWithJson}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const preQuizJsonUrl = computed(() => preQuizEditIframeUrl.value || preQuizUrl.value)

const hasPreQuizContent = computed(() =>
	hasInlineQuestions((props.callout as any)?.preQuiz)
)

const preQuizFrameUrl = computed(() => {
  if (!preQuizEditIframeUrl.value) return ""
  const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : "#/"
  const params = new URLSearchParams({
    sourceUrl: preQuizEditIframeUrl.value
  })
  if (props.selectedLanguage) {
    params.set("lng", String(props.selectedLanguage))
  }
  return `${baseUrl}prequiz-frame?${params.toString()}`
})

const assessmentBaseUrl = computed(() => {
	const links = (props.callout as any)?._links ?? {}
	return String(
		links?.assessment?.href ??
		links?.assessmentQuiz?.href ??
		links?.preQuizAssesment?.href ??
		links?.preQuizAssessment?.href ??
		''
	).trim()
})

const hasAssessment = computed(() => {
	const assessmentQuestions = (props.callout as any)?.assessment?.questions
	const quizQuestions = (props.callout as any)?.assessmentQuiz?.questions
	return assessmentBaseUrl.value !== '' || [assessmentQuestions, quizQuestions].some((questions) => Array.isArray(questions) && questions.length > 0)
})

const showConfiguredAssessmentButton = computed(() =>
  isAssessmentButtonEnabled.value &&
  hasAssessment.value &&
  Boolean(configuredAssessmentUrl.value)
)

const showLocalAssessmentButton = computed(() =>
  isAssessmentButtonEnabled.value &&
  hasAssessment.value &&
  !showConfiguredAssessmentButton.value
)

const assessmentQuizUrl = computed(() => {
  const baseUrl = assessmentBaseUrl.value
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

watch(
	[isAssessmentMetadataPreferred, assessmentQuizUrl, inlineAssessmentMetadata],
	async ([preferAssessmentMetadata, url, inlineMetadata], _prev, onCleanup) => {
		if (!preferAssessmentMetadata) {
			resetFetchedAssessmentMetadata()
			return
		}

		if (!url) {
			resetFetchedAssessmentMetadata()
			return
		}

		const hasInlineTitle = Boolean(inlineMetadata.title)
		const hasInlineLeadText = Boolean(inlineMetadata.leadText)
		if (hasInlineTitle && hasInlineLeadText) {
			resetFetchedAssessmentMetadata()
			return
		}

		resetFetchedAssessmentMetadata()
		const controller = new AbortController()
		onCleanup(() => controller.abort())

		try {
			const response = await fetch(url, {
				method: 'GET',
				headers: { Accept: 'application/json' },
				signal: controller.signal
			})

			if (!response.ok) {
				return
			}

			const contentType = response.headers.get('content-type') ?? ''
			if (!contentType.includes('application/json')) {
				return
			}

			const data = await response.json()
			const parsedMetadata = readAssessmentMetadataFromCallout(data)
			fetchedAssessmentMetadata.value = {
				title: parsedMetadata.title || '',
				leadText: parsedMetadata.leadText || ''
			}
		} catch (error) {
			if ((error as Error).name !== 'AbortError') {
				// Keep mainOutcome fallback if metadata fetch fails.
			}
		}
	},
	{ immediate: true }
)

const postQuizUrl = computed(() => {
  const baseUrl = props.callout._links?.postQuiz?.href ?? ""
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const hasPostQuizContent = computed(() => hasInlineQuestions((props.callout as any)?.postQuiz))

const postQuizEditIframeUrl = computed(() => {
  const baseUrl = props.callout._links?.postQuizEdit?.href ?? props.callout._links?.postQuiz?.href ?? ""
  if (!baseUrl) return ""
  const url = resolveApiUrl(baseUrl)
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""

  if (url) {
    const packageId = extractPackageIdFromUrl(url) || props.callout.identifier || ""
    url.searchParams.set("json", "y")
    url.searchParams.set("package", "SAT")
    url.searchParams.set("packageid", packageId)
    url.searchParams.set("packageLng", packageLng)
    url.searchParams.set("sourcereqid", sourcereqid)
    return url.toString()
  }

  const id = props.callout.identifier ?? ""
  const urlWithJson = /[?&]json=/.test(baseUrl)
    ? baseUrl.replace(/([?&]json=)[^&#]*/, "$1y")
    : `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}json=y`
  const separator = urlWithJson.includes("?") ? "&" : "?"
  return `${urlWithJson}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const postQuizJsonUrl = computed(() => postQuizEditIframeUrl.value || postQuizUrl.value)

const postQuizFrameUrl = computed(() => {
  if (!postQuizEditIframeUrl.value) return ""
  const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : "#/"
  const params = new URLSearchParams({
    sourceUrl: postQuizEditIframeUrl.value
  })
  if (props.selectedLanguage) {
    params.set("lng", String(props.selectedLanguage))
  }
  return `${baseUrl}postquiz-frame?${params.toString()}`
})

const keyMessagesUrl = computed(() => {
  const baseUrl = props.callout._links?.mainOutcomeEdit?.href ?? ""
  if (!baseUrl) return ""
  const url = resolveApiUrl(baseUrl)
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""

  if (url) {
    const packageId = extractPackageIdFromUrl(url) || props.callout.identifier || ""
    url.searchParams.set("json", "y")
    url.searchParams.set("package", "SAT")
    url.searchParams.set("packageid", packageId)
    url.searchParams.set("packageLng", packageLng)
    url.searchParams.set("sourcereqid", sourcereqid)
    return url.toString()
  }

  const id = props.callout.identifier ?? ""
  const urlWithJson = /[?&]json=/.test(baseUrl)
    ? baseUrl.replace(/([?&]json=)[^&#]*/, "$1y")
    : `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}json=y`
  const separator = urlWithJson.includes("?") ? "&" : "?"
  return `${urlWithJson}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const keyMessagesFrameUrl = computed(() => {
  if (!keyMessagesUrl.value) return ""
  const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : "#/"
  const params = new URLSearchParams({
    sourceUrl: keyMessagesUrl.value
  })
  if (props.selectedLanguage) {
    params.set("lng", String(props.selectedLanguage))
  }
  return `${baseUrl}keymessages-frame?${params.toString()}`
})

const keyMessagesEditUrl = computed(() => {
  const baseUrl = props.callout._links?.mainOutcomeEdit?.href ?? ""
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const playerFileUrl = computed(() => {
  const baseUrl = props.callout.file_url ?? ""
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const editPackageUrl = computed(() => {
  const baseUrl = AppConfig.urls.editPackage ?? ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  const editAllUrl = `${baseUrl}${separator}id=${id}&full_package=y&lng=${packageLng}&sourcereqid=${sourcereqid}`
  return editAllUrl
})

const getListBaseUrl = () => {
	const raw = String(AppConfig.urls.getList ?? '').trim()
	if (!raw) {
		return ''
	}

	try {
		const url = new URL(raw, window.location.origin)
		url.search = ''
		url.hash = ''
		return url.toString().replace(/\/$/, '')
	} catch {
		return raw.replace(/[?#].*$/, '').replace(/\/$/, '')
	}
}

const detailsItemLng = computed(() => {
	const itemLng = String(props.callout.mainOutcome?.lng ?? '').trim()
	if (itemLng) {
		return itemLng
	}
	return String(props.selectedLanguage ?? currentLng.value ?? '').trim()
})

const applyDetailsContext = (rawUrl: string) => {
	try {
		const url = new URL(rawUrl, window.location.origin)
		url.searchParams.set('json', 'y')
		url.searchParams.set('mode', 'details')
		const selectedLng = detailsItemLng.value
		if (selectedLng) {
			url.searchParams.set('lng', selectedLng)
		}
		if (currentCollectionMode.value) {
			url.searchParams.set('collection-mode', String(currentCollectionMode.value))
		}
		if (currentTestyourself.value) {
			url.searchParams.set('testYourself', String(currentTestyourself.value))
		}
		if (currentPAGE_REQ_ID.value) {
			url.searchParams.set('PAGE_REQ_ID', String(currentPAGE_REQ_ID.value))
		}
		return url.toString()
	} catch {
		const params = new URLSearchParams({
			json: 'y',
			mode: 'details',
		})
		const selectedLng = detailsItemLng.value
		if (selectedLng) {
			params.set('lng', selectedLng)
		}
		if (currentCollectionMode.value) {
			params.set('collection-mode', String(currentCollectionMode.value))
		}
		if (currentTestyourself.value) {
			params.set('testYourself', String(currentTestyourself.value))
		}
		if (currentPAGE_REQ_ID.value) {
			params.set('PAGE_REQ_ID', String(currentPAGE_REQ_ID.value))
		}
		const separator = rawUrl.includes('?') ? '&' : '?'
		return `${rawUrl}${separator}${params.toString()}`
	}
}

const learnMoreDetailsUrl = computed(() => {
	const baseApi = getListBaseUrl()
	const identifier = props.callout.identifier
	if (baseApi && identifier) {
		return applyDetailsContext(`${baseApi}/${encodeURIComponent(String(identifier))}`)
	}

	const explicitDetailsUrl = String(props.callout._links?.details?.href ?? '').trim()
	if (explicitDetailsUrl) {
		return applyDetailsContext(explicitDetailsUrl)
	}
	return ''
})


onBeforeUnmount(() => {
//   sessionStorage.setItem('listScrollPosition', window.scrollY.toString());
});

onMounted(() => {
//   const savedScroll = sessionStorage.getItem('listScrollPosition');
//   if (savedScroll) {
//     setTimeout(() => {
//       window.scrollTo({
//         top: parseInt(savedScroll),
//         behavior: 'auto'
//       });
//       sessionStorage.removeItem('listScrollPosition');
//     }, 50); // delay i vogël për të pritur DOM-in
//   }
});
</script>

<style>
span.p-image.p-component.p-image-preview-container.rounded{
	width:100%;
}
.p-tooltip {
	font-size: 13px;
}

.p-inplace-display {
	display: flex;
	padding: 0;
	margin: 0;
}

#leadText .p-inplace-display {
	display: flex;
	padding: 0;
	margin: 0;
	align-items: end;
}

.drop-zone {
	border: 2px dashed #ccc;
	padding: 20px;
	margin: 10px 0;
	text-align: center;
	cursor: pointer;
}

.image-zone img {
	max-width: 100%;
	height: auto;
}

.spinnerAssistant {
   width: 24px;
   height: 24px;
   border-radius: 50%;
   border: 3px solid;
   border-color: transparent;
   border-left-color: var(--danger);
   border-right-color: var(--danger);
   animation: spinner-d3wgkg 1s infinite linear;
}

@keyframes spinner-d3wgkg {
   to {
      transform: rotate(1turn);
   }
}
.p-dropdown-panel .p-dropdown-items {
    padding: 0.25rem 0.25rem;
}

#editKeyMessaggesWrapper > ol{
    list-style: decimal-leading-zero !important;
    margin: 0 1em !important;
    padding: 0 20px 0 20px !important;
}
#editKeyMessaggesWrapper > ul, #editKeyMessaggesWrapper > menu {
    list-style: disc !important;
    margin: 0 1em !important;
    padding: 0 20px 0 20px !important;
}
.disabled {
  opacity: 0.5;
background-color:#ddd;	
  pointer-events: none;
  cursor:not-allowed;
}
.p-image-mask.p-component-overlay.p-component-overlay-enter{
    z-index: 8888;
}
</style>
